<script>
    import { onMount } from "svelte";
    import { apiMethods } from "../../Services/index.svelte";

    import {
        getAmountInCurrency,
        showError,
        showException,
        splitPaymentAmount,
    } from "../../Utils/utilFunctions.svelte";

    import { user } from "../../stores";

    import { DecimalInput } from "./index.svelte";

    export let row = {};
    export let type;
    export let onFinish = () => {};

    $: canUserEdit = $user.role == 100;

    $: rowIncludesGST =
        type == "ReceiptsTable"
            ? row.payments[0]?.includesGST
            : row.includesGST;

    let isEditModalOpen = false,
        isUpdatingAmount = false,
        editAmount,
        backUpAmount,
        editProcessingFee,
        backUpProcessingFee;

    onMount(() => {
        editAmount = _getEditAmountByType();
        backUpAmount = _getEditAmountByType();
        editProcessingFee = _getEditProcessingFeeByType();
        backUpProcessingFee = _getEditProcessingFeeByType();
    });

    const updateAmount = async () => {
        isUpdatingAmount = true;

        if (type == "ReceiptsTable") await updateReceipt();
        else if (
            type == "EstimatePaymentsTable" ||
            type == "InvoicePaymentTable" ||
            type == "PatientEncounterPaymentTable"
        )
            await updatePayment(row);

        closeEditModal();

        isUpdatingAmount = false;
    };

    const updateReceipt = async () => {
        const selectPayment = row.payments[0];

        await updatePayment(selectPayment);
    };

    const updatePayment = async (payment) => {
        payment.amount = editAmount;

        payment.processingFee = editProcessingFee;

        if (rowIncludesGST)
            payment.amount = payment.amount * 1.1 + payment.processingFee;
        else payment.amount += payment.processingFee;

        await apiMethods.putMethod
            .updatePayment({ ...payment })
            .then((res) => {
                if (res.error) showError(res.error);
                else onFinish();
            })
            .catch((err) => showException(err));
    };

    const openEditModal = () => {
        editAmount = _getEditAmountByType();
        backUpAmount = _getEditAmountByType();

        isEditModalOpen = true;
    };

    const closeEditModal = () => {
        editAmount = _getEditAmountByType();
        backUpAmount = _getEditAmountByType();

        isEditModalOpen = false;
    };

    // HELPER FUNCTIONS
    const _getEditAmountByType = () => {
        switch (type) {
            case "ReceiptsTable":
                return Number(splitPaymentAmount(row.payments[0]).amount);
            case "EstimatePaymentsTable":
            case "InvoicePaymentTable":
            case "PatientEncounterPaymentTable":
                return Number(splitPaymentAmount(row).amount);
            default:
                return "";
        }
    };

    const _getEditProcessingFeeByType = () => {
        switch (type) {
            case "ReceiptsTable":
                return Number(splitPaymentAmount(row.payments[0]).processing);
            case "EstimatePaymentsTable":
            case "InvoicePaymentTable":
            case "PatientEncounterPaymentTable":
                return Number(splitPaymentAmount(row).processing);
            default:
                return "";
        }
    };
</script>

<div class="flex items-center justify-start">
    {#if !canUserEdit}
        <p class="text-left cursor-default">
            {getAmountInCurrency(_getEditAmountByType())}
        </p>
    {:else}
        <p
            class="text-left cursor-pointer underline"
            on:click|preventDefault={openEditModal}
        >
            {getAmountInCurrency(editAmount)}
        </p>
    {/if}
</div>

<div class={isEditModalOpen ? "modal modal-open sm:modal-middle" : "modal"}>
    <div class="modal-box p-0">
        <h3
            class="font-medium text-lg text-[#fff] flex-0 bg-[#8a3ed7] px-6 py-3"
        >
            Update Amount
        </h3>

        <div class="flex flex-col gap-y-4 p-6">
            <p class="w-full text-lg">Payment Amount:</p>
            <DecimalInput inputClass="w-full" bind:value={editAmount} />
        </div>

        {#if rowIncludesGST}
            <div class="flex flex-col gap-y-4 p-6">
                <p class="w-full text-lg">Processing Fee:</p>
                <DecimalInput
                    inputClass="w-full"
                    bind:value={editProcessingFee}
                />
            </div>
        {/if}

        <div
            class="modal-action flex items-center gap-x-4 justify-end p-6 pt-0"
        >
            <button
                class="btn btn-error text-white btn-sm border-none w-24"
                disabled={isUpdatingAmount}
                on:click={closeEditModal}
            >
                Close
            </button>

            <button
                class="btn btn-secondary text-white btn-sm border-none {isUpdatingAmount
                    ? 'w-36 loading'
                    : 'w-24'}"
                disabled={isUpdatingAmount}
                on:click={updateAmount}
            >
                {isUpdatingAmount ? "Updating" : "Update"}
            </button>
        </div>
    </div>
</div>
